import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiPrinter, FiMail, FiMapPin } from 'react-icons/fi';

/**
 * Footer 컴포넌트
 * 병원 정보, 빠른 링크, 진료시간, 저작권 정보를 포함하는 푸터
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 병원 정보 */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">트레넷 안과의원</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <FiMapPin className="w-5 h-5 mt-1 flex-shrink-0 text-accent" />
                <div>
                  <p className="text-sm">서울특별시 강남구 테헤란로 123</p>
                  <p className="text-xs text-gray-400">
                    (역삼동 123-45)
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <FiPhone className="w-5 h-5 flex-shrink-0 text-accent" />
                <a
                  href="tel:02-1234-5678"
                  className="text-sm hover:text-accent transition-colors"
                >
                  02-1234-5678
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <FiPrinter className="w-5 h-5 flex-shrink-0 text-accent" />
                <span className="text-sm">02-1234-5679</span>
              </div>
              <div className="flex items-center space-x-2">
                <FiMail className="w-5 h-5 flex-shrink-0 text-accent" />
                <a
                  href="mailto:contact@treneteye.com"
                  className="text-sm hover:text-accent transition-colors"
                >
                  contact@treneteye.com
                </a>
              </div>
            </div>
          </div>

          {/* 빠른 링크 */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">빠른 링크</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm hover:text-accent transition-colors"
                >
                  병원소개
                </Link>
              </li>
              <li>
                <Link
                  to="/doctors"
                  className="text-sm hover:text-accent transition-colors"
                >
                  의료진소개
                </Link>
              </li>
              <li>
                <Link
                  to="/treatment"
                  className="text-sm hover:text-accent transition-colors"
                >
                  진료안내
                </Link>
              </li>
              <li>
                <Link
                  to="/info"
                  className="text-sm hover:text-accent transition-colors"
                >
                  오시는 길
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm hover:text-accent transition-colors"
                >
                  상담문의
                </Link>
              </li>
            </ul>
          </div>

          {/* 진료시간 안내 */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">진료시간</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>평일</span>
                <span className="text-white">09:00 - 18:00</span>
              </div>
              <div className="flex justify-between">
                <span>토요일</span>
                <span className="text-white">09:00 - 13:00</span>
              </div>
              <div className="flex justify-between">
                <span>일요일/공휴일</span>
                <span className="text-red-400">휴진</span>
              </div>
              <div className="pt-2 border-t border-gray-700">
                <p className="text-xs text-gray-400">점심시간: 12:30 - 13:30</p>
                <p className="text-xs text-gray-400 mt-1">
                  토요일은 점심시간 없이 진료합니다
                </p>
              </div>
            </div>
          </div>

          {/* 추가 정보 */}
          <div>
            <h3 className="text-white text-lg font-bold mb-4">
              Trenet Eye Clinic
            </h3>
            <p className="text-sm mb-4">
              밝은 세상을 위한 눈 건강 파트너
            </p>
            <div className="space-y-2 text-xs text-gray-400">
              <p>대표원장: 김민수</p>
              <p>사업자등록번호: 123-45-67890</p>
              <p>의료기관 인증번호: 제2024-서울강남-0001호</p>
            </div>
          </div>
        </div>

        {/* 저작권 */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-400">
            Copyright © {currentYear} Trenet Eye Clinic. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
